import { render, staticRenderFns } from "./AppToolsReplacePosSale.vue?vue&type=template&id=3a6c85fb"
import script from "./AppToolsReplacePosSale.vue?vue&type=script&lang=ts"
export * from "./AppToolsReplacePosSale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports